import {
  GetSalariesDistributionDocument,
  GetSalariesDistributionQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type SalaryDistribution = NonNullable<
  GetSalariesDistributionQuery['jobCatalog']['salariesDistributionsConnection']['nodes'][number]
>

export const useSalariesDistribution = (roleId: string): [SalaryDistribution[], boolean] => {
  const { data, loading } = useQuery(GetSalariesDistributionDocument, {
    variables: {
      roleId: roleId,
    },
  })

  return [data ? data?.jobCatalog.salariesDistributionsConnection.nodes : [], loading]
}
